import React from 'react'
import { StepRoot, StepGrid, ContentPanel } from '../styles'

interface StepLayoutProps {
  // The panel element itself, not just its contents: each partner's SidePanel
  // has its own padding and width, so the wrapper stays with the caller.
  sidebar?: React.ReactNode
  children: React.ReactNode
}

const StepLayout = ({ sidebar, children }: StepLayoutProps) => (
  <StepRoot>
    <StepGrid hasSidebar={!!sidebar}>
      <ContentPanel>{children}</ContentPanel>
      {sidebar}
    </StepGrid>
  </StepRoot>
)

export default StepLayout
